// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__UoR5b","main":"Privacy_main__1veoi","head":"Privacy_head__2Ofeu","top":"Privacy_top__1ncJG","sub":"Privacy_sub__3E0MI","body":"Privacy_body__35SwR"};